import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const ErrorPage = () => {
  return (
    <Style>
      <div>
        <img
          className="logo"
          src={`${process.env.PUBLIC_URL}/knockknock/img/logo.png`}
          alt="logo"
        />
        <p>비정상적인 접근입니다</p>
        <p>QR을 통해서 재접속해 주세요</p>
        <img
          className="notFound"
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_not_found.svg`}
          alt="logo"
        />
      </div>
    </Style>
  );
};
export default ErrorPage;

const Style = styled.div`
  div {
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2%;
  }
  img.logo {
    position: absolute;
    top: 3%;
    left: 3%;
    width: 14%;
  }
  p {
    font-size: 4.5vw;
    font-weight: 600;
  }
  img.notFound {
    margin-top: 8%;
    width: 30%;
  }
`;
